// List of Treechat developer usernames, excluded from analytics/metrics.
// Lives in its own module so UI code can reference it without statically
// importing MetricsViewer (which would pull echarts into the entry bundle).
export const TREECHAT_DEVS = ['arghzero', 'metamitya']
